export default "__VITE_ASSET__BgQoL_z1__"